import { PriorityTaskQueue } from "owa-task-queue";

/**
 * Initialize the get persona photo task queue.
 * The queue will control how many getPersonaPhoto requests to make at any given point
 */
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!, replace this line with a justification or fix the issue.
 *	> Function PriorityTaskQueue called at module scope is not allowed. This may cause unwanted side effects. */
const getPersonaPhotoQueue: PriorityTaskQueue<void> = new PriorityTaskQueue<void>({
    taskDelay: 500,
});

export default getPersonaPhotoQueue;
